import { createRoute } from "@tanstack/react-router";

import { root } from "routes";

import Layout from "theme/ui/Layout";

import type { ContentFilters } from "./models";
import Contents from "./pages/Contents";
import Content from "./pages/Content";


const _root = createRoute({
	getParentRoute: () => root,
	path: "content",
	component: () => <Layout.Light />
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "/",
	component: () => <Contents />,
	validateSearch: () => ({}) as ContentFilters
});

const content = createRoute({
	getParentRoute: () => _root,
	path: "/$id",
	component: () => <Content />
});

const partners = _root.addChildren([index, content]);
export default partners;